
import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";

const Registration = () => {
  const { register } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const result = await register(formData);

    setMessage(result.message);
    setIsError(!result.success);

    if (result.success) {
      setTimeout(() => navigate("/login"), 1800);
    }
  };

  return (
    <div className="register-page">
      <style>{`
        /* =========================================================
           PAGE
           The registration section fills the space between
           navbar and footer.
           ========================================================= */

        .register-page {
          width: 100%;
          min-height: calc(100vh - 140px);

          display: flex;
          align-items: center;
          justify-content: center;

          box-sizing: border-box;

          padding: 35px 20px;

          background:
            radial-gradient(
              circle at top left,
              rgba(59, 130, 246, 0.25),
              transparent 40%
            ),
            radial-gradient(
              circle at bottom right,
              rgba(124, 58, 237, 0.25),
              transparent 40%
            ),
            linear-gradient(
              135deg,
              #0f172a,
              #020617
            );

          overflow-x: hidden;
        }

        /* =========================================================
           CARD
           ========================================================= */

        .register-card {
          width: 100%;
          max-width: 460px;

          box-sizing: border-box;

          padding: 32px;

          background: rgba(255, 255, 255, 0.08);

          backdrop-filter: blur(25px);
          -webkit-backdrop-filter: blur(25px);

          border: 1px solid rgba(255, 255, 255, 0.08);

          border-radius: 28px;

          box-shadow:
            0 40px 100px rgba(0, 0, 0, 0.5);

          animation: registerCardIn 0.45s ease-out;
        }

        @keyframes registerCardIn {
          from {
            opacity: 0;
            transform: translateY(15px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* =========================================================
           HEADER
           ========================================================= */

        .title {
          color: #ffffff;

          text-align: center;

          font-size: 2rem;
          font-weight: 900;

          letter-spacing: -1px;

          line-height: 1.2;
        }

        .subtitle {
          color: rgba(255, 255, 255, 0.6);

          text-align: center;

          margin-top: 6px;
          margin-bottom: 24px;

          font-size: 14px;

          line-height: 1.5;
        }

        /* =========================================================
           INPUTS
           ========================================================= */

        .input {
          display: block;

          width: 100%;

          box-sizing: border-box;

          padding: 13px 14px;

          margin: 0 0 14px;

          border-radius: 14px;

          border: 1px solid rgba(255, 255, 255, 0.12);

          background: rgba(255, 255, 255, 0.06);

          color: #ffffff;

          outline: none;

          font-size: 15px;

          transition:
            border-color 0.2s ease,
            box-shadow 0.2s ease,
            background 0.2s ease;
        }

        .input::placeholder {
          color: rgba(255, 255, 255, 0.4);
        }

        .input:focus {
          border-color: rgba(79, 140, 255, 0.65);

          background: rgba(255, 255, 255, 0.08);

          box-shadow:
            0 0 0 3px rgba(79, 140, 255, 0.15);
        }

        /* =========================================================
           BUTTON
           ========================================================= */

        .btn-primary {
          display: block;

          width: 100%;

          box-sizing: border-box;

          padding: 13px;

          border: none;

          border-radius: 14px;

          color: #ffffff;

          background:
            linear-gradient(
              135deg,
              #2563eb,
              #4f46e5
            );

          font-size: 15px;
          font-weight: 800;

          cursor: pointer;

          transition:
            transform 0.25s ease,
            box-shadow 0.25s ease;
        }

        .btn-primary:hover {
          transform: translateY(-2px);

          box-shadow:
            0 20px 50px rgba(37, 99, 235, 0.35);
        }

        .btn-primary:active {
          transform: translateY(0);
        }

        /* =========================================================
           MESSAGE
           ========================================================= */

        .msg {
          padding: 12px;

          margin-bottom: 14px;

          border-radius: 12px;

          font-size: 13px;

          line-height: 1.4;

          border: 1px solid;
        }

        .error {
          background: rgba(239, 68, 68, 0.1);

          color: #fca5a5;

          border-color:
            rgba(239, 68, 68, 0.3);
        }

        .success {
          background: rgba(34, 197, 94, 0.1);

          color: #86efac;

          border-color:
            rgba(34, 197, 94, 0.3);
        }

        /* =========================================================
           FOOTER LINK INSIDE CARD
           ========================================================= */

        .footer-text {
          text-align: center;

          margin-top: 18px;

          color: rgba(255, 255, 255, 0.6);

          font-size: 13px;
        }

        .link {
          color: #60a5fa;

          font-weight: 700;

          text-decoration: none;
        }

        .link:hover {
          text-decoration: underline;
        }

        /* =========================================================
           TABLET
           ========================================================= */

        @media (max-width: 768px) {
          .register-page {
            /*
             * Navbar + footer take less space on tablet.
             */
            min-height: calc(100vh - 120px);

            padding: 28px 16px;
          }

          .register-card {
            max-width: 440px;

            padding: 28px 24px;

            border-radius: 24px;
          }

          .title {
            font-size: 1.75rem;
          }

          .subtitle {
            margin-bottom: 20px;
          }
        }

        /* =========================================================
           MOBILE
           ========================================================= */

        @media (max-width: 480px) {
          .register-page {
            /*
             * IMPORTANT:
             * Card remains centered between navbar and footer.
             */
            min-height: calc(100vh - 110px);

            width: 100%;

            padding:
              18px 12px
              22px;

            align-items: center;
            justify-content: center;
          }

          .register-card {
            width: 100%;

            max-width: 100%;

            padding:
              24px 18px;

            border-radius: 20px;

            box-shadow:
              0 25px 60px rgba(0, 0, 0, 0.45);
          }

          .title {
            font-size: 1.55rem;

            letter-spacing: -0.5px;
          }

          .subtitle {
            font-size: 13px;

            margin-top: 5px;

            margin-bottom: 19px;
          }

          .input {
            padding: 12px 13px;

            margin-bottom: 12px;

            border-radius: 12px;

            font-size: 14px;
          }

          .btn-primary {
            padding: 12px;

            border-radius: 12px;

            font-size: 14px;
          }

          .footer-text {
            margin-top: 16px;

            font-size: 12px;
          }

          .msg {
            padding: 10px;

            margin-bottom: 12px;

            font-size: 12px;
          }
        }

        /* =========================================================
           SMALL MOBILE
           ========================================================= */

        @media (max-width: 360px) {
          .register-page {
            min-height: calc(100vh - 100px);

            padding:
              12px 8px
              18px;
          }

          .register-card {
            padding:
              20px 15px;

            border-radius: 18px;
          }

          .title {
            font-size: 1.4rem;
          }

          .subtitle {
            font-size: 12px;

            margin-bottom: 16px;
          }

          .input {
            padding: 11px 12px;

            font-size: 13px;
          }

          .btn-primary {
            padding: 11px;

            font-size: 13px;
          }
        }

        /* =========================================================
           SHORT MOBILE SCREENS
           Prevent the card from being cut off vertically.
           ========================================================= */

        @media (max-width: 480px) and (max-height: 700px) {
          .register-page {
            align-items: flex-start;

            padding-top: 14px;
            padding-bottom: 20px;
          }

          .register-card {
            padding:
              20px 17px;
          }

          .subtitle {
            margin-bottom: 15px;
          }

          .input {
            margin-bottom: 10px;
          }

          .footer-text {
            margin-top: 13px;
          }
        }
      `}</style>

      <div className="register-card">
        <div className="title">
          Create Account
        </div>

        <div className="subtitle">
          Start selling in minutes with MyIdeaShop
        </div>

        {message && (
          <div
            className={`msg ${
              isError ? "error" : "success"
            }`}
          >
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <input
            className="input"
            type="text"
            name="name"
            placeholder="Full name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            className="input"
            type="email"
            name="email"
            placeholder="Email address"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            className="input"
            type="password"
            name="password"
            placeholder="Create password"
            value={formData.password}
            onChange={handleChange}
            required
          />

          <button
            className="btn-primary"
            type="submit"
          >
            Create Account
          </button>
        </form>

        <div className="footer-text">
          Already have an account?{" "}
          <Link
            className="link"
            to="/login"
          >
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Registration;

